import React from "react";
import { BadgeCheck } from "lucide-react";

// Sammarinese verified badge — shown next to user names everywhere.
export default function VerifiedBadge({ size = "sm", showLabel = false, className = "" }) {
  const sizeCls = size === "xs" ? "w-3 h-3" : size === "md" ? "w-5 h-5" : "w-4 h-4";
  return (
    <span
      title="Profilo verificato — residenza San Marino confermata"
      aria-label="Profilo verificato"
      className={`inline-flex items-center gap-1 text-sky-600 ${className}`}
      data-testid="verified-badge"
    >
      <BadgeCheck className={`${sizeCls} fill-sky-100 stroke-[2.2]`} />
      {showLabel && <span className="text-[10px] font-bold uppercase tracking-wider">Verificato</span>}
    </span>
  );
}
